/* Lonsmere · Black November 2026 · contagem regressiva única para barra, hero e PDP */
(function(){
  var END = Date.UTC(2026, 10, 30, 23, 59, 59); /* 30 Nov 2026, 23:59:59 em Londres (GMT) */
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var left = END - Date.now();
    var els = document.querySelectorAll('[data-lbn]');
    if (left <= 0){
      for (var i = 0; i < els.length; i++) els[i].classList.add('lbn-off');
      return false;
    }
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    var shortTxt = d > 0 ? d + 'd ' + pad(h) + 'h' : pad(h) + 'h ' + pad(m) + 'm';
    var q = document.querySelectorAll('[data-lbn-short]');
    for (var j = 0; j < q.length; j++) q[j].textContent = shortTxt;
    var parts = {d: pad(d), h: pad(h), m: pad(m), s: pad(sec)};
    var u = document.querySelectorAll('[data-lbn-unit]');
    for (var k = 0; k < u.length; k++) u[k].textContent = parts[u[k].getAttribute('data-lbn-unit')];
    return true;
  }
  if (tick()){
    var t = setInterval(function(){ if (!tick()) clearInterval(t); }, 1000);
  }
})();
